module.exports = __webpack_public_path__ + "static/logo-011104dea01497f892988b038fe07c67.svg";